export const WX_JSAPI_URL = 'https://res.wx.qq.com/open/js/jweixin-1.0.0.js'
export const WX_SHARE_API = process.env.VUE_APP_WX_SIGNATURE_URL
